/**
 * 종목 표시명 — 미국주식은 티커, 국내는 한글 종목명 (캡틴 확정 2026-08-27)
 * 매매 시점 페이지와 전 페이지 통일 규칙.
 */
import { isOverseasStock } from "src/components/StockDetailDrawer";

/** stockId로 해외 판별 가능하면 티커, 아니면 원래 이름 */
export const displayStockName = (name: string, stockId?: string): string => {
  if (stockId && isOverseasStock(stockId)) return stockId;
  return name;
};
